import * as yup from 'yup'

export interface FormValues {
  quantity: number
  frequency: number
}

export const validation = yup
  .object()
  .shape({
    quantity: yup
      .string(),

    frequency: yup
      .number()
      .required('A frequency must be entered')
      .max(20, 'The frequency cannot be bigger than 20 weeks')
      .min(2, 'The frequency cannot be less than 2 weeks')
  })
